import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const OnboardingLink = ({ label }) => (
    <div className="pal t4">
        <Link to="/hva-er-trygg-betaling">{label}</Link>
    </div>
);

OnboardingLink.propTypes = {
    label: PropTypes.string.isRequired,
};

OnboardingLink.defaultProps = {
    label: 'Hvordan fungerer Trygg betaling?',
};

export default OnboardingLink;



// WEBPACK FOOTER //
// ./safeTrade/status/onboardingLink.jsx